import React, { useEffect } from "react";
import {
  Button,
  Group,
  Modal,
  Stack,
  TextInput,
  Textarea,
  useMantineTheme,
} from "@mantine/core";
import { useForm } from "@mantine/form";
import ColorPalette from "./ColorPalette";
import { DESCRIPTION_MAX_LENGTH } from "./constants";

const EMPTY_CATEGORY = { name: "", description: "", color: "" };

const CategoryModal = ({
  opened,
  onClose,
  onSubmit,
  initialValues,
  mode = "create",
  isSaving = false,
}) => {
  const form = useForm({
    initialValues: initialValues || EMPTY_CATEGORY,
    validate: {
      name: (v) => (v?.trim().length ? null : "Category name is required"),
      color: (v) => (v ? null : "Please choose a color"),
    },
  });

  useEffect(() => {
    // reset/prefill when modal opens or initialValues change
    if (opened) {
      form.setValues(initialValues || EMPTY_CATEGORY);
      form.resetDirty(initialValues || EMPTY_CATEGORY);
    } else {
      form.reset();
    }
  }, [opened, initialValues]);

  const title = mode === "edit" ? "Edit Category" : "Add Category";
  const submitLabel = mode === "edit" ? "Save" : "Add";
  const theme = useMantineTheme();
  return (
    <Modal opened={opened} onClose={onClose} title={title} centered>
      <form
        onSubmit={form.onSubmit((values) => {
          onSubmit(values);
        })}
      >
        <Stack spacing="md">
          <TextInput
            label="Category name"
            placeholder="e.g. Strategic RFPs"
            {...form.getInputProps("name")}
          />
          <Textarea
            label="Description"
            description="What this category groups together. The AI reads this when it tags meetings."
            placeholder="e.g. Every competitive bid we respond to, from qualification through submission."
            maxLength={DESCRIPTION_MAX_LENGTH}
            autosize
            minRows={3}
            maxRows={6}
            {...form.getInputProps("description")}
          />
          <div>
            <div style={{ fontSize: 14, marginBottom: 6, fontWeight: 500 }}>
              Color
            </div>
            <ColorPalette
              value={form.values.color}
              onChange={(c) => form.setFieldValue("color", c)}
              options={Object.keys(theme.colors)}
            />
          </div>
          <Group position="right" mt="sm">
            <Button variant="default" onClick={onClose} type="button">
              Cancel
            </Button>
            <Button type="submit" loading={isSaving}>
              {submitLabel}
            </Button>
          </Group>
        </Stack>
      </form>
    </Modal>
  );
};

export default CategoryModal;
